import { render, staticRenderFns } from "./login3pv.vue?vue&type=template&id=606da33b&"
import script from "./login3pv.vue?vue&type=script&lang=js&"
export * from "./login3pv.vue?vue&type=script&lang=js&"
import style0 from "./login3pv.vue?vue&type=style&index=0&id=606da33b&prod&lang=css&"
import style1 from "./login3pv.vue?vue&type=style&index=1&id=606da33b&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports